import type { MayBe } from 'modules/global/typing/common/common';
import * as types from 'modules/hardwares/actionTypes';
import type { OpenHardwareCreateModalAction } from 'modules/hardwares/types';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

type CreationModalState = {
  isOpen: boolean;
  // `null` initially, the hardware id when editing, `undefined` when opened in creation mode.
  selectedHardware: MayBe<string> | null;
};

const initialState: CreationModalState = {
  isOpen: false,
  selectedHardware: null,
};

const open = (_: CreationModalState, { payload }: OpenHardwareCreateModalAction): CreationModalState => ({
  isOpen: true,
  selectedHardware: payload,
});

const hide = (): CreationModalState => initialState;

export default createReducer(initialState, {
  [types.OPEN_CREATE_HARDWARE_MODAL]: open,
  [types.HIDE_CREATE_HARDWARE_MODAL]: hide,
  [types.LINK_HARDWARE_SUCCESS]: hide,
  [types.PATCH_STATUS_HARDWARE_SUCCESS]: hide,
  [LOCATION_CHANGE]: hide,
});
